/**
 * 全局Loading组件插件
 * 提供 $loading 服务，支持链式调用
 */

import Vue from 'vue'
import AjLoading from './index.vue'

// 创建组件构造器
const LoadingComponent = Vue.extend(AjLoading)

let loadingInstance = null

// 创建并挂载loading实例
function createLoadingInstance() {
  if (!loadingInstance) {
    const container = document.createElement('div')
    document.body.appendChild(container)
    loadingInstance = new LoadingComponent().$mount(container)
  }
  return loadingInstance
}

export default {
  /**
   * 安装插件
   * @param {Vue} Vue Vue实例
   */
  install(VueInstance) {
    // 创建全局$loading方法
    VueInstance.prototype.$loading = {
      /**
       * 显示loading
       * @param {Object|string} options 配置项或直接传文字
       * @returns {Object} loading实例，包含close和setProgress方法
       */
      show(options = {}) {
        const instance = createLoadingInstance()
        if (typeof options === 'string') {
          options = { text: options }
        }
        instance.open(options)
        return instance
      },
      /**
       * 关闭loading
       */
      close() {
        if (loadingInstance) {
          loadingInstance.close()
        }
      },
      /**
       * 设置进度
       * @param {number} value 进度值 0-100
       */
      setProgress(value) {
        if (loadingInstance) {
          loadingInstance.setProgress(value)
        }
      }
    }

    // 保留组件形式的使用方式
    VueInstance.component(AjLoading.name, AjLoading)
  }
}
